let base;
let domain = window.location.host;
let hotelType = domain.indexOf('localhost') !== -1
switch (domain) {
  case 'cloud.hotel.xinjingtech.net': // 正式酒店
    base = 'https://cdn.xinjngtech.com/'
    // base = 'https://test.cdn.xinjngtech.com/'
    break;
  case 'pre.xinjngtech.com': //  酒店预发布环境      
    base = 'https://cdn.xinjngtech.com/'
    break;
  case 'test.xinjngtech.com': // 测试酒店
    base = 'https://test.cdn.xinjngtech.com/'
    break;
  case 'dev.xinjngtech.com': //  酒店本地环境   
    base = 'https://test.cdn.xinjngtech.com/'
    break;
  default:
    if (hotelType) {
      console.log(hotelType, 'url--------')
      base = 'https://test.cdn.xinjngtech.com/'
    } else {

      base = window.location.protocol + '//' + (process.env.NODE_IMG_DOMAIN || window.location.host) + '/default/';
    }
    break;
}
export default base;



// WEBPACK FOOTER //
// ./src/api/imgUrl.js